import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private readonly http: HttpClient) { }

  public get(localFilePath: string) {
    return this.http.get<Blob>(localFilePath, {
      responseType: 'blob' as 'json',
    });
  }
}
